module.exports = __webpack_public_path__ + "img/prevent-4-pic.55bc2a36.jpg";